<template>
  <div>
    <right-panel class="float-right" :id="id" width="400px" @hidden="rightPanelClosed">
      <content-loading v-if="!atLeastShow" />

      <div v-if="atLeastShow" class="pl-5 pr-5 position-relative pb-5">
        <!---->
        <h5>
          {{ $t("inventory.filter.plural") }}
        </h5>

        <h6 class="mb-0 mt-2 text-muted">{{ $t("department.text") }}</h6>
        <filter-select
          id="departmentFilter"
          ref="departmentFilter"
          :selected="criteria.department"
          @filter="onDepartmentSearch"
          @changed="onDepartmentSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("process.text") }}</h6>
        <filter-select
          id="processFilter"
          ref="processFilter"
          :selected="criteria.process"
          @filter="onProcessSearch"
          @changed="onProcessSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("datasource.text") }}</h6>
        <filter-select
          id="datasourceFilter"
          ref="datasourceFilter"
          :selected="criteria.datasource"
          @filter="onDatasourceSearch"
          @changed="onDatasourceSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("data-category.text") }}</h6>
        <filter-select
          id="dataCategoryFilter"
          ref="dataCategoryFilter"
          :selected="criteria.dataCategory"
          @filter="onDataCategorySearch"
          @changed="onDataCategorySelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("data.text") }}</h6>
        <filter-select id="dataFilter" ref="dataFilter" :selected="criteria.data" @filter="onDataSearch" @changed="onDataSelect" :placeholder="$t('common.choose')" />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("datasubject.text") }}</h6>
        <filter-select
          id="datasubjectFilter"
          ref="datasubjectFilter"
          :selected="criteria.datasubject"
          @filter="onDatasubjectSearch"
          @changed="onDatasubjectSelect"
          :placeholder="$t('common.choose')"
        />

        <h4 class="mt-4 text-muted">
          {{ $t("inventory.filter.inventory-features") }}
        </h4>

        <h6 class="mb-0 mt-2 text-muted">{{ $t("direct-collect-method.text") }}</h6>
        <filter-select
          id="directCollectFilter"
          ref="directCollectFilter"
          :selected="criteria.directCollectMethod"
          @filter="onDirectCollectMethodSearch"
          @changed="onDirectCollectMethodSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("other-collect-method.text") }}</h6>
        <filter-select
          id="otherCollectFilter"
          ref="otherCollectFilter"
          :selected="criteria.otherCollectMethod"
          @filter="onOtherCollectMethodSearch"
          @changed="onOtherCollectMethodSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("physical-storage.text") }}</h6>
        <filter-select
          id="physicalStorageFilter"
          ref="physicalStorageFilter"
          :selected="criteria.physicalStorage"
          @filter="onPhysicalStorageSearch"
          @changed="onPhysicalStorageSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("physical-storage.period-alt") }} ({{ $t("common.month") }})</h6>
        <input class="form-control form-control-sm" type="number" :value="criteria.physicalStoragePeriod" @input="onPhysicalStoragePeriod($event)" />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("physical-archive.text") }}</h6>
        <filter-select
          id="physicalArchiveFilter"
          ref="physicalArchiveFilter"
          :selected="criteria.physicalArchive"
          @filter="onPhysicalArchiveSearch"
          @changed="onPhysicalArchiveSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("electronic-storage.text") }}</h6>
        <filter-select
          id="electronicStorageFilter"
          ref="electronicStorageFilter"
          :selected="criteria.electronicStorage"
          @filter="onElectronicStorageSearch"
          @changed="onElectronicStorageSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("electronic-storage.period-alt") }} ({{ $t("common.month") }})</h6>
        <input class="form-control form-control-sm" type="number" :value="criteria.electronicStoragePeriod" @input="onElectronicStoragePeriod($event)" />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("electronic-archive.text") }}</h6>
        <filter-select
          id="electronicArchiveFilter"
          ref="electronicArchiveFilter"
          :selected="criteria.electronicArchive"
          @filter="onElectronicArchiveSearch"
          @changed="onElectronicArchiveSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("disposal-method.text") }}</h6>
        <filter-select
          id="disposalMethodFilter"
          ref="disposalMethodFilter"
          :selected="criteria.disposalMethod"
          @filter="onDisposalMethodSearch"
          @changed="onDisposalMethodSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("accessing-persons.name") }}</h6>
        <filter-select
          id="dataAccessorFilter"
          ref="dataAccessorFilter"
          :selected="criteria.dataAccessor"
          @filter="onDataAccessorSearch"
          @changed="onDataAccessorSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("processing.purpose.text") }}</h6>
        <filter-select
          id="processingPurposeFilter"
          ref="processingPurposeFilter"
          :selected="criteria.processingPurpose"
          @filter="onProcessingPurposeSearch"
          @changed="onProcessingPurposeSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("processing.legal-reason") }}</h6>
        <filter-select
          id="processingLegalReasonFilter"
          ref="processingLegalReasonFilter"
          :selected="criteria.processingLegalReason"
          @filter="onProcessingLegalReasonSearch"
          @changed="onProcessingLegalReasonSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("transfering.purpose.text") }}</h6>
        <filter-select
          id="transferingPurposeFilter"
          ref="transferingPurposeFilter"
          :selected="criteria.transferingPurpose"
          @filter="onTransferingPurposeSearch"
          @changed="onTransferingPurposeSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("transfering.legal-reason") }}</h6>
        <filter-select
          id="transferingLegalReasonFilter"
          ref="transferingLegalReasonFilter"
          :selected="criteria.transferingLegalReason"
          @filter="onTransferingLegalReasonSearch"
          @changed="onTransferingLegalReasonSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("transfering.method.text") }}</h6>
        <filter-select
          id="transferingMethodFilter"
          ref="transferingMethodFilter"
          :selected="criteria.transferingMethod"
          @filter="onTransferingMethodSearch"
          @changed="onTransferingMethodSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("receiver-group.text") }}</h6>
        <filter-select
          id="receiverGroupFilter"
          ref="receiverGroupFilter"
          :selected="criteria.receiverGroup"
          @filter="onReceiverGroupSearch"
          @changed="onReceiverGroupSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("thirdparty.text") }}</h6>
        <filter-select
          id="thirdPartyFilter"
          ref="thirdPartyFilter"
          :selected="criteria.thirdParty"
          @filter="onThirdPartySearch"
          @changed="onThirdPartySelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("datasubject-right.text") }}</h6>
        <filter-select
          id="datasubjectRightFilter"
          ref="datasubjectRightFilter"
          :selected="criteria.datasubjectRight"
          @filter="onDatasubjectRightSearch"
          @changed="onDatasubjectRightSelect"
          :placeholder="$t('common.choose')"
        />

        <div style="display: flex; gap: 1rem; position: fixed; top: 0.2rem; right: 3rem;">
          <sweet-button @click="apply()" variant="success" icon="bx bx-check" size="sm" buttonClass="mt-2">
            {{ $t("inventory.filter.apply") }}
          </sweet-button>

          <sweet-button @click="clear()" variant="secondary" icon="bx bx-x" size="sm" buttonClass="mt-2 float-right">
            {{ $t("common.clear") }}
          </sweet-button>
        </div>

        <!---->
      </div>
    </right-panel>
    <!---->

    <sweet-button v-if="hasFilter" @click="clear()" variant="light" icon="bx bx-x" size="sm" buttonClass="mt-2 mr-2">
      {{ $t("inventory.filter.clear") }}
    </sweet-button>
    <sweet-button @click="toggleSidebar()" variant="info" icon="mdi mdi-filter" size="sm" buttonClass="mt-2 mr-2">
      {{ $t("inventory.filter.text") }}
    </sweet-button>
  </div>
</template>

<script>
export default {
  props: ["id"],
  computed: {
    criteria() {
      return this.$store.getters["inventoryFilter/criteria"];
    },
    hasFilter() {
      return Object.keys(this.criteria).find((i) => !!this.criteria[i]);
    },
  },

  data() {
    return { atLeastShow: false };
  },

  methods: {
    async onDepartmentSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartment/paginateForSearch`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDepartmentSelect(item) {
      this.$store.commit("inventoryFilter/department", item);
      this.$refs.processFilter.reset();
    },

    //Process
    async onProcessSearch(value, callback) {
      if (!this.criteria.department) {
        const response = await this.$store.dispatch(`organizationProcess/paginateForSearch`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });

        callback(response.data?.docs ?? []);
      } else {
        const response = await this.$store.dispatch(`organizationDepartmentProcess/paginateForSearch`, {
          options: { limit: 1000 },
          query: { name: { value }, department: { value: { _id: this.criteria.department._id }, isObject: true } },
        });

        callback(response.data?.docs ?? []);
      }
    },
    onProcessSelect(item) {
      this.$store.commit("inventoryFilter/process", item);
      this.$refs.datasourceFilter.reset();
    },

    //Datasource
    async onDatasourceSearch(value, callback) {
      if (!this.criteria.department) {
        const response = await this.$store.dispatch(`organizationDatasource/paginateForSearch`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });

        callback(response.data?.docs ?? []);
      } else if (this.criteria.process) {
        const response = await this.$store.dispatch(`organizationProcessDatasource/paginateForSearch`, {
          options: { limit: 1000 },
          query: { name: { value }, process: { value: { _id: this.criteria.process._id }, isObject: true } },
        });

        callback(response.data?.docs ?? []);
      }
    },
    onDatasourceSelect(item) {
      this.$store.commit("inventoryFilter/datasource", item);
      this.$refs.dataCategoryFilter.reset();
    },

    //Datacategory
    async onDataCategorySearch(value, callback) {
      if (this.criteria.department && this.criteria.process && this.criteria.datasource) {
        const response = await this.$store.dispatch("organizationProcessDatasource/paginateDatasourceOwnedDataCategories", {
          pagination: { options: { limit: 1000 } },
          processDatasourceId: this.criteria.datasource._id,
        });

        callback(response.data?.docs ?? []);
      } else {
        const response = await this.$store.dispatch(`organizationDataCategory/paginateForSearch`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });
        callback(response.data?.docs ?? []);
      }
    },
    onDataCategorySelect(item) {
      this.$store.commit("inventoryFilter/dataCategory", item);
      this.$refs.dataFilter.reset();
    },

    //Data
    async onDataSearch(value, callback) {
      if (!this.criteria.department) {
        const response = await this.$store.dispatch(`organizationData/paginateForSearch`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });

        callback(response.data?.docs ?? []);
      } else if (this.criteria.datasource) {
        const query = {
          name: { value },
          datasource: {
            value: { _id: this.criteria.datasource._id },
            isObject: true,
          },
        };

        if (this.criteria.dataCategory) {
          query.category = { value: { _id: this.criteria.dataCategory._id }, isObject: true };
        }
        const response = await this.$store.dispatch(`organizationDatasourceData/paginateForSearch`, {
          options: { limit: 1000 },
          query,
        });

        callback(response.data?.docs ?? []);
      }
    },
    onDataSelect(item) {
      this.$store.commit("inventoryFilter/data", item);
      this.$refs.datasubjectFilter.reset();
    },

    //Datasubject
    async onDatasubjectSearch(value, callback) {
      if (this.criteria.department && this.criteria.process && this.criteria.datasource && this.criteria.data) {
        const response = await this.$store.dispatch(`organizationDataDatasubject/paginateForSearch`, {
          options: { limit: 1000 },
          query: { name: { value }, data: { value: { _id: this.criteria.data._id }, isObject: true } },
        });

        callback(response.data?.docs ?? []);
      } else {
        const response = await this.$store.dispatch(`organizationDatasubject/paginateForSearch`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });
        callback(response.data?.docs ?? []);
      }
    },
    onDatasubjectSelect(item) {
      this.$store.commit("inventoryFilter/datasubject", item);
    },

    /** Envanter Özellikleri */

    //DirectCollectMethod
    async onDirectCollectMethodSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDirectCollectMethod/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDirectCollectMethodSelect(item) {
      this.$store.commit("inventoryFilter/directCollectMethod", item);
    },

    //OtherCollectMethod
    async onOtherCollectMethodSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationOtherCollectMethod/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onOtherCollectMethodSelect(item) {
      this.$store.commit("inventoryFilter/otherCollectMethod", item);
    },

    //PhysicalStorage
    async onPhysicalStorageSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationPhysicalStorage/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onPhysicalStorageSelect(item) {
      this.$store.commit("inventoryFilter/physicalStorage", item);
    },

    onPhysicalStoragePeriod($e) {
      const value = $e.target.value;
      this.$store.commit("inventoryFilter/physicalStoragePeriod", value);
    },

    onElectronicStoragePeriod($e) {
      const value = $e.target.value;
      this.$store.commit("inventoryFilter/electronicStoragePeriod", value);
    },
    //PhysicalArchive
    async onPhysicalArchiveSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationPhysicalArchive/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onPhysicalArchiveSelect(item) {
      this.$store.commit("inventoryFilter/physicalArchive", item);
    },

    //ElectronicStorage
    async onElectronicStorageSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationElectronicStorage/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onElectronicStorageSelect(item) {
      this.$store.commit("inventoryFilter/electronicStorage", item);
    },

    //ElectronicArchive
    async onElectronicArchiveSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationElectronicArchive/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onElectronicArchiveSelect(item) {
      this.$store.commit("inventoryFilter/electronicArchive", item);
    },

    //DisposalMethod
    async onDisposalMethodSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDisposalMethod/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDisposalMethodSelect(item) {
      this.$store.commit("inventoryFilter/disposalMethod", item);
    },

    //DataAccessor
    async onDataAccessorSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDataAccessor/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDataAccessorSelect(item) {
      this.$store.commit("inventoryFilter/dataAccessor", item);
    },

    //ProcessingPurpose
    async onProcessingPurposeSearch(value, callback) {
      const response = await this.$store.dispatch(`purpose/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onProcessingPurposeSelect(item) {
      this.$store.commit("inventoryFilter/processingPurpose", item);
    },

    //ProcessingLegalReason
    async onProcessingLegalReasonSearch(value, callback) {
      const response = await this.$store.dispatch(`legalReason/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onProcessingLegalReasonSelect(item) {
      this.$store.commit("inventoryFilter/processingLegalReason", item);
    },

    //TransferingPurpose
    async onTransferingPurposeSearch(value, callback) {
      const response = await this.$store.dispatch(`purpose/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onTransferingPurposeSelect(item) {
      this.$store.commit("inventoryFilter/transferingPurpose", item);
    },

    //TransferingLegalReason
    async onTransferingLegalReasonSearch(value, callback) {
      const response = await this.$store.dispatch(`legalReason/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onTransferingLegalReasonSelect(item) {
      this.$store.commit("inventoryFilter/transferingLegalReason", item);
    },

    //TransferingMethod
    async onTransferingMethodSearch(value, callback) {
      const response = await this.$store.dispatch(`method/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onTransferingMethodSelect(item) {
      this.$store.commit("inventoryFilter/transferingMethod", item);
    },

    //ReceiverGroup
    async onReceiverGroupSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationReceiverGroup/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onReceiverGroupSelect(item) {
      this.$store.commit("inventoryFilter/receiverGroup", item);
    },

    //ThirdParty
    async onThirdPartySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationThirdParty/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onThirdPartySelect(item) {
      this.$store.commit("inventoryFilter/thirdParty", item);
    },

    //DatasubjectRight
    async onDatasubjectRightSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDatasubjectRight/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDatasubjectRightSelect(item) {
      this.$store.commit("inventoryFilter/datasubjectRight", item);
    },

    //
    apply() {
      this.$emit("apply");
      this.toggleSidebar();
    },
    clear() {
      this.$store.commit("inventoryFilter/clear");
      if (this.atLeastShow) {
        this.$refs?.departmentFilter?.reset();
        this.$refs?.processFilter?.reset();
        this.$refs?.datasourceFilter?.reset();
        this.$refs?.dataCategoryFilter?.reset();
        this.$refs?.dataFilter?.reset();
        this.$refs?.datasubjectFilter?.reset();
        this.$refs?.directCollectFilter?.reset();
        this.$refs?.otherCollectFilter?.reset();
        this.$refs?.physicalStorageFilter?.reset();
        this.$refs?.physicalArchiveFilter?.reset();
        this.$refs?.electronicStorageFilter?.reset();
        this.$refs?.electronicArchiveFilter?.reset();
        this.$refs?.disposalMethodFilter?.reset();
        this.$refs?.dataAccessorFilter?.reset();
        this.$refs?.processingPurposeFilter?.reset();
        this.$refs?.processingLegalReasonFilter?.reset();
        this.$refs?.transferingPurposeFilter?.reset();
        this.$refs?.transferingLegalReasonFilter?.reset();
        this.$refs?.receiverGroupFilter?.reset();
        this.$refs?.thirdPartyFilter?.reset();
        this.$refs?.datasubjectRightFilter?.reset();
      }

      this.$emit("apply");
    },

    toggleSidebar() {
      this.$root.$emit("bv::toggle::collapse", this.id);
      setTimeout(() => (this.atLeastShow = true), 100);
    },
    rightPanelClosed() {},
  },
};
</script>
